<ion-header class="modal-header">
  <div class="modal-title">
    <h3>{{ readOnly ? "View" : "Configure" }} Global Custom Fields</h3>
  </div>
  <ion-toolbar>
    <ion-buttons slot="end">
      <ion-button
        fill="clear"
        shape="round"
        class="close-button"
        (click)="dismiss()"
      >
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <div style="padding: 16px">
    <app-custom-fields
      *ngIf="fields"
      [customFields]="fields"
      [placeholder]="'Ex: Favorite color'"
      [addCustomFieldButtonLabel]="'Add a global custom field'"
      [showPublicOption]="true"
      [showUserAttributeOption]="false"
      [showBranchingInput]="true"
      [showDescription]="true"
      contextPrefix="conversation.ticketTypeFields"
      [readOnly]="true"
      [projectId]="projectId"
    >
    </app-custom-fields>
  </div>
</ion-content>

<ion-footer class="footer flex-space-between">
  <ion-button (click)="submit()" [disabled]="isLoading || readOnly">
    Save
    <ion-spinner
      name="crescent"
      [hidden]="!isLoading"
      style="margin-left: 10px"
    ></ion-spinner>
  </ion-button>
</ion-footer>
